import { Calculated } from "../../models/Dilution";

export const getCalculatedOnChangeFieldInput =
  (onChange: (...args: unknown[]) => void) => (event: CustomEvent<string>) =>
    onChange({
      calculatedValue: event.detail,
      displayedValue: event.detail,
    } as Calculated);
